import { Dictionary } from "lodash";
import { TextChip, BoolChip, ArrayChip, RangeChip, RatingChip, NumericChip } from "marketplace/_views/filters/filter-chip";

export type FilterChipType = TextChip | BoolChip | ArrayChip | RangeChip | RatingChip | NumericChip;

export class FilterChips {
  private _chips: FilterChipType[];

  public constructor(filterChips: FilterChipType[] = []) {
    this._chips = filterChips;
  }

  public get chips() {
    return this._chips;
  }

  public findByName(filterName: string): FilterChipType | undefined {
    return this._chips.find(chip => chip.filterName === filterName);
  }

  public add(chip: FilterChipType) {
    this._chips.push(chip);
  }

  public addRange(chips: FilterChipType[]) {
    this._chips = chips;
  }

  public remove(filterName: string): boolean {
    let index = this._chips.findIndex(chip => chip.filterName === filterName);

    if (index === -1) return false;
    this._chips.splice(index, 1);

    return true;
  }

  public enable(filterName: string): boolean {
    let currentChip = this.findByName(filterName);

    if (!currentChip) return false;

    currentChip.enable();

    return true;
  }

  public disable(filterName: string): boolean {
    let currentChip = this.findByName(filterName);

    if (!currentChip) return false;

    currentChip.disable();

    return true;
  }

  public disableAll(): void {
    for (const chip of this._chips) {
      chip.disable();
    }
  }

  public updateValue(filterName: string, value: string | string[]): boolean {
    let currentChip = this.findByName(filterName);

    if (!currentChip) return false;
    
    if (currentChip instanceof ArrayChip || currentChip instanceof RangeChip) {
      if (!Array.isArray(value)) value = [value];
      currentChip.updateValue(value);
    } else {
      currentChip.updateValue(value.toString());
    }

    return true;
  }

  public toDictionary() : Dictionary<string> {
    let dictionary: Dictionary<string> = {};

    for (const chip of this._chips) {
      dictionary[chip.filterName] = chip.value?.toString() ?? '';
    }

    return dictionary;
  }
}
